import { batch } from 'react-redux';
import { deleteLocalDraft } from '@ff-os/pdp-shared-redux/apis/localDrafts';
import { Pdp } from '@ff-os/pdp-shared-registry/Pdp';
import { toList } from '@ff-os/shared-utils/dictionaries';
import { upgrade } from '@ff-os/shared-utils/upgrades/upgrades';
import { actions as groupActions } from '@ff-scene-plugins/photo-prints-redux/slices/groupsSlice';
import { actions as photoActions } from '@ff-scene-plugins/photo-prints-redux/slices/photosSlice';
import { actions as versionActions } from '@ff-scene-plugins/photo-prints-redux/slices/versionSlice';
import { PhotoPrintsPdpDispatch, PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { PhotoPrintsJson } from '@ff-scene-plugins/photo-prints-shared/PhotoPrintsJson';
import { photoPrintsUpgrades } from '@ff-scene-plugins/photo-prints-shared/upgrades/photoPrintsUpgrades';
import { setShowProjectIsIncompatible } from '../_redux-ui';
import { prepareUiState } from './prepareUiState';

export const openProject = async (
    project: PhotoPrintsJson.Project,
    isCompatible: boolean,
    source: Pdp.Scene.ProjectSource,
    dispatch: PhotoPrintsPdpDispatch,
    getState: () => PhotoPrintsPdpState
) => {

    if (!isCompatible) {

        if (source === 'draft') {
            dispatch(deleteLocalDraft());
        } else {
            dispatch(setShowProjectIsIncompatible(true));
        }

        return { continue: false };
    }

    project = upgrade(project, { allUpgrades: photoPrintsUpgrades });

    batch(() => {
        dispatch(versionActions.overwrite(project.version));
        dispatch(groupActions.setAll(toList(project.groups.entities)));
        dispatch(photoActions.setAll(toList(project.photos.entities)));
    });

    prepareUiState(dispatch, getState);

    return { continue: true };
};